(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-maxx-tracking"] && !Shopify.designMode) return;
  try {
    
if (!window.veluneMaxxTrackingInstalled) {
  window.veluneMaxxTrackingInstalled = true;
  let provider;

  const loadProvider = () => {
    if (window.YQV5) return Promise.resolve();
    if (provider) return provider;

    provider = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => {
        script.remove();
        reject(new Error('timeout'));
      }, 12000);

      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = () => {
        clearTimeout(timer);
        window.YQV5 ? resolve() : reject(new Error('unavailable'));
      };
      script.onerror = () => {
        clearTimeout(timer);
        script.remove();
        reject(new Error('network'));
      };
      document.head.append(script);
    }).catch((error) => {
      provider = null;
      throw error;
    });

    return provider;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const scope = form.closest('[data-maxx-tracking]');
    if (!scope) return;

    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;

    const number = form.elements.nums.value.trim();
    if (!form.reportValidity()) return;

    const status = scope.querySelector('[data-track-status]');
    const fallback = scope.querySelector('[data-track-fallback]');
    fallback.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(number);
    fallback.hidden = false;
    button.disabled = true;
    status.textContent = status.dataset.loading;

    try {
      await loadProvider();
      if (!scope.isConnected) return;
      window.YQV5.trackSingle({
        YQ_ContainerId: scope.querySelector('[data-track-result]').id,
        YQ_Height: 560,
        YQ_Fc: '0',
        YQ_Lang: 'en',
        YQ_Num: number
      });
      status.textContent = '';
    } catch (error) {
      status.textContent = status.dataset.error;
    } finally {
      button.disabled = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-product-details-global"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velune-product-details')) {
    class VeluneProductDetails extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('.velune-product-details__tab'));
        this.panels = Array.from(this.querySelectorAll('.velune-product-details__panel'));
        this.boundClick = this.handleClick.bind(this);
        this.closeAll();
        this.addEventListener('click', this.boundClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundClick);
      }

      handleClick(event) {
        const tab = event.target.closest('.velune-product-details__tab');
        if (!tab || !this.contains(tab)) return;
        const wasOpen = tab.getAttribute('aria-expanded') === 'true';

        this.closeAll();

        if (!wasOpen) this.open(tab);
      }

      closeAll() {
        this.tabs.forEach((tab) => {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-expanded', 'false');
        });

        this.panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
        });
      }

      open(selectedTab) {
        const panelId = selectedTab.getAttribute('aria-controls');
        const panel = this.ownerDocument.getElementById(panelId);
        if (!panel || !this.contains(panel)) return;

        selectedTab.classList.add('is-active');
        selectedTab.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
      }
    }

    customElements.define('velune-product-details', VeluneProductDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velune-product-details')) {
    class VeluneProductDetails extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('.velune-product-details__tab'));
        this.panels = Array.from(this.querySelectorAll('.velune-product-details__panel'));
        this.boundClick = this.handleClick.bind(this);
        this.closeAll();
        this.addEventListener('click', this.boundClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundClick);
      }

      handleClick(event) {
        const tab = event.target.closest('.velune-product-details__tab');
        if (!tab || !this.contains(tab)) return;
        const wasOpen = tab.getAttribute('aria-expanded') === 'true';

        this.closeAll();

        if (!wasOpen) this.open(tab);
      }

      closeAll() {
        this.tabs.forEach((tab) => {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-expanded', 'false');
        });

        this.panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
        });
      }

      open(selectedTab) {
        const panelId = selectedTab.getAttribute('aria-controls');
        const panel = this.ownerDocument.getElementById(panelId);
        if (!panel || !this.contains(panel)) return;

        selectedTab.classList.add('is-active');
        selectedTab.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
      }
    }

    customElements.define('velune-product-details', VeluneProductDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-reels-slider')) {
  customElements.define('velune-reels-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.track = this.querySelector('[data-vvs-track]');
      this.dialog = this.querySelector('[data-vvs-dialog]');
      if (!this.track || !this.dialog) return;
      this.modalHost = this.querySelector('[data-vvs-modal-host]');
      this.hint = this.querySelector('[data-vvs-play-hint]');
      this.originals = Array.from(this.track.children);
      this.videos = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.autoScroll === 'true';
      this.speed = Math.max(10, Math.min(100, Number(this.dataset.speed) || 30));
      this.direction = this.dataset.direction === 'right' ? -1 : 1;
      this.visible = false;
      this.hovered = false;
      this.keyboardMode = false;
      this.selected = false;
      this.touching = 0;
      this.pointers = new Map();
      this.suppressClickUntil = 0;
      this.resumeAt = 0;
      this.frame = 0;
      this.resumeTimer = 0;
      this.lastTime = 0;
      this.width = -1;
      this.visibleVideos = new Set();
      const listen = (target, event, callback, options = {}) =>
        target.addEventListener(event, callback, { ...options, signal: this.controller.signal });
      this.listen = listen;
      this.videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) {
            this.visibleVideos.add(target);
            if (!document.hidden && !this.constructor.activePreview) this.play(target);
          } else {
            this.visibleVideos.delete(target);
            target.pause();
          }
        });
      }, { rootMargin: '100px 0px', threshold: 0.01 }) : null;
      if ('IntersectionObserver' in window) {
        this.sectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        });
        this.sectionObserver.observe(this);
      } else this.visible = true;
      listen(document, 'visibilitychange', () => {
        this.refreshPlayback();
        if (document.hidden) this.modalVideo?.pause();
        this.schedule();
      });
      listen(document, 'vvs:preview-change', () => {
        this.refreshPlayback();
        if (!this.constructor.activePreview) this.resumeAfterTouch();
        else this.schedule();
      });
      listen(document, 'keydown', () => { this.keyboardMode = true; this.schedule(); });
      listen(document, 'pointerdown', () => { this.keyboardMode = false; }, { passive: true });
      listen(this.track, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.pauseHover === 'true') {
          this.hovered = true;
          this.schedule();
        }
      });
      listen(this.track, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.resumeAfterTouch();
      });
      listen(this.track, 'pointerdown', event => {
        this.keyboardMode = false;
        this.pointers.set(event.pointerId, {
          x: event.clientX, y: event.clientY, time: performance.now(),
          scroll: this.track.scrollLeft, moved: false
        });
        this.schedule();
      }, { passive: true });
      listen(window, 'pointermove', event => {
        const pointer = this.pointers.get(event.pointerId);
        if (pointer && Math.hypot(event.clientX - pointer.x, event.clientY - pointer.y) > 10) pointer.moved = true;
      }, { passive: true });
      const release = event => {
        const pointer = this.pointers.get(event.pointerId);
        if (!pointer) return;
        if (event.type === 'pointercancel' || pointer.moved || performance.now() - pointer.time > 400 ||
          Math.abs(this.track.scrollLeft - pointer.scroll) > 10) this.suppressClickUntil = performance.now() + 600;
        this.pointers.delete(event.pointerId);
        this.resumeAfterTouch();
      };
      listen(window, 'pointerup', release, { passive: true });
      listen(window, 'pointercancel', release, { passive: true });
      listen(this.track, 'touchstart', event => {
        this.touching = event.touches.length;
        this.schedule();
      }, { passive: true });
      const touchEnd = event => {
        if (!this.touching) return;
        this.touching = event.touches.length;
        this.resumeAfterTouch();
      };
      listen(window, 'touchend', touchEnd, { passive: true });
      listen(window, 'touchcancel', touchEnd, { passive: true });
      listen(window, 'blur', () => {
        this.pointers.clear();
        this.touching = 0;
        this.hovered = false;
        this.resumeAfterTouch();
      });
      listen(this.track, 'wheel', () => this.resumeAfterTouch(), { passive: true });
      listen(this.track, 'focusin', () => this.schedule());
      listen(this.track, 'focusout', () => queueMicrotask(() => {
        if (this.controller) this.resumeAfterTouch();
      }));
      listen(this, 'shopify:block:select', () => { this.selected = true; this.schedule(); });
      listen(this, 'shopify:block:deselect', () => { this.selected = false; this.resumeAfterTouch(); });
      listen(this.track, 'click', event => {
        const button = event.target.closest('[data-vvs-open]');
        if (!button || (event.detail !== 0 && performance.now() < this.suppressClickUntil)) return;
        const source = button.closest('.vvs-item').querySelector('video');
        if (source) this.openVideo(source, button);
      });
      listen(this.querySelector('[data-vvs-close]'), 'click', () => this.closeVideo());
      listen(this.dialog, 'cancel', event => { event.preventDefault(); this.closeVideo(); });
      listen(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)
          this.closeVideo();
      });
      listen(this.dialog, 'close', () => this.finishClose());
      listen(this.motion, 'change', () => { this.width = -1; this.layout(); });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this.track);
      } else listen(window, 'resize', () => this.layout());
      this.layout();
    }
    play(video) {
      const result = video.play();
      if (result?.catch) result.catch(() => {});
    }
    refreshPlayback() {
      this.videos.forEach(video => {
        if (document.hidden || this.constructor.activePreview || !this.visibleVideos.has(video)) video.pause();
        else this.play(video);
      });
    }
    resumeAfterTouch() {
      this.resumeAt = performance.now() + 3000;
      this.schedule();
    }
    openVideo(source, opener) {
      if (this.dialog.open || this.constructor.activePreview) return;
      this.opener = opener;
      this.hint.hidden = true;
      const video = source.cloneNode(true);
      video.removeAttribute('id');
      video.removeAttribute('muted');
      video.removeAttribute('autoplay');
      video.removeAttribute('tabindex');
      video.setAttribute('loading', 'eager');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      video.className = 'vvs-modal-video';
      video.controls = true;
      video.loop = false;
      video.defaultMuted = false;
      video.muted = false;
      video.volume = 1;
      video.preload = 'auto';
      video.disablePictureInPicture = true;
      this.modalController = new AbortController();
      this.modalVideo = video;
      this.modalHost.replaceChildren(video);
      this.dialog.showModal();
      this.constructor.activePreview = this;
      const rootStyle = document.documentElement.style;
      this.savedOverflow = { value: rootStyle.getPropertyValue('overflow'), priority: rootStyle.getPropertyPriority('overflow') };
      rootStyle.setProperty('overflow', 'hidden');
      document.dispatchEvent(new CustomEvent('vvs:preview-change'));
      video.addEventListener('error', () => {
        if (this.modalVideo !== video) return;
        this.hint.textContent = this.dataset.errorLabel;
        this.hint.hidden = false;
      }, { once: true, signal: this.modalController.signal });
      const result = video.play();
      if (result?.catch) result.catch(() => {
        if (this.modalVideo !== video || !this.dialog.open || this.closing) return;
        this.hint.textContent = this.dataset.playHint;
        this.hint.hidden = false;
      });
      video.addEventListener('playing', () => { this.hint.hidden = true; }, { signal: this.modalController.signal });
    }
    closeVideo() {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      this.modalVideo?.pause();
      if (this.motion.matches || !this.dialog.animate) {
        this.dialog.close();
        return;
      }
      this.closeAnimation = this.dialog.animate([
        { opacity: 1, transform: 'translateY(0) scale(1)' },
        { opacity: 0, transform: 'translateY(6px) scale(0.98)' }
      ], { duration: 140, easing: 'ease-out', fill: 'forwards' });
      this.closeAnimation.finished.then(() => {
        if (this.dialog.open) this.dialog.close();
      }).catch(() => {});
    }
    finishClose() {
      this.closeAnimation?.cancel();
      this.closeAnimation = null;
      this.closing = false;
      this.modalController?.abort();
      this.modalController = null;
      if (this.modalVideo) {
        this.modalVideo.pause();
        this.modalVideo.removeAttribute('src');
        this.modalVideo.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.modalVideo.load();
        this.modalVideo.remove();
        this.modalVideo = null;
      }
      if (this.savedOverflow) {
        const { value, priority } = this.savedOverflow;
        if (value) document.documentElement.style.setProperty('overflow', value, priority);
        else document.documentElement.style.removeProperty('overflow');
        this.savedOverflow = null;
      }
      if (this.constructor.activePreview === this) {
        this.constructor.activePreview = null;
        document.dispatchEvent(new CustomEvent('vvs:preview-change'));
      }
      if (!this.controller || !this.isConnected) return;
      this.hovered = false;
      this.pointers.clear();
      this.touching = 0;
      if (this.needsLayout) { this.needsLayout = false; this.layout(); }
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      this.resumeAfterTouch();
    }
    layout() {
      if (this.dialog.open) { this.needsLayout = true; return; }
      const width = this.track.clientWidth;
      if (width === this.width || !width) return;
      this.width = width;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.resumeTimer);
      this.frame = 0;
      this.videoObserver?.disconnect();
      this.visibleVideos.clear();
      this.track.querySelectorAll('[data-vvs-clone]').forEach(card => {
        card.querySelector('video')?.pause();
        card.remove();
      });
      this.originals.forEach(card => this.track.append(card));
      this.loop = this.enabled && !this.motion.matches && this.originals.length > 0;
      this.track.classList.toggle('vvs-track--loop', this.loop);
      if (this.loop) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = this.originals[0].offsetWidth + gap;
        const count = Math.ceil((Math.ceil(width / this.step) + 4) / this.originals.length) * this.originals.length;
        for (let index = this.originals.length; index < count; index++) {
          const clone = this.originals[index % this.originals.length].cloneNode(true);
          clone.dataset.vvsClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('button, a, video, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
          const video = clone.querySelector('video');
          if (video) { video.muted = true; video.preload = 'none'; }
          this.track.append(clone);
        }
        this.track.prepend(this.track.lastElementChild);
        this.position = this.step;
        this.track.scrollLeft = this.position;
      } else this.track.scrollLeft = 0;
      this.videos = Array.from(this.track.querySelectorAll('video'));
      this.videos.forEach(video => {
        video.muted = true;
        if (this.videoObserver) this.videoObserver.observe(video);
        else { this.visibleVideos.add(video); if (!document.hidden && !this.constructor.activePreview) this.play(video); }
      });
      this.schedule();
    }
    canRun() {
      return this.loop && !this.hovered && !this.pointers.size && !this.touching && !this.selected &&
        !this.constructor.activePreview && this.visible && !document.hidden &&
        !(this.keyboardMode && this.track.contains(document.activeElement));
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.resumeTimer);
      this.frame = 0;
      this.lastTime = 0;
      if (!this.controller || !this.canRun()) return;
      const delay = this.resumeAt - performance.now();
      if (delay > 0) {
        this.resumeTimer = setTimeout(() => this.schedule(), delay);
        return;
      }
      this.position = this.track.scrollLeft;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      this.frame = 0;
      if (!this.isConnected || !this.canRun()) return;
      const elapsed = this.lastTime ? Math.min(time - this.lastTime, 50) : 0;
      this.lastTime = time;
      this.position += this.direction * this.speed * elapsed / 1000;
      while (this.position >= this.step * 2) {
        this.track.append(this.track.firstElementChild);
        this.position -= this.step;
      }
      while (this.position < this.step) {
        this.track.prepend(this.track.lastElementChild);
        this.position += this.step;
      }
      this.track.scrollLeft = this.position;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.resumeTimer);
      this.closeAnimation?.cancel();
      if (this.dialog?.open) this.dialog.close();
      this.finishClose();
      this.videoObserver?.disconnect();
      this.sectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.videos.forEach(video => video.pause());
      this.querySelectorAll('[data-vvs-clone]').forEach(card => card.remove());
      this.originals?.forEach(card => this.track.append(card));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
